module.exports = __webpack_public_path__ + "static/img/login-main-logo.e952a022.jpg";